export default {
  touchPointPage: {
    buyerInfo: 'delivery_purchase_buyer_info',
    myDeliveries: 'my_deliveries',
    deliveryPurchases: 'delivery_orders_buyer',
    deliverySales: 'delivery_orders_seller',
    deliveryOverview: 'delivery_overview',
    deliveryOrdersAcceptDeal: 'delivery_orders_accept_deal',
    deliverySellerConfirmationSubmit: 'delivery_seller_confirmation_submit',
    returns: {
      returnOverview: 'delivery_return_overview',
      returnDetails: 'delivery_return_details',
      returnError: 'delivery_return_error',
    },
  },
  events: {
    deliveryHelpBuyer: 'delivery_help_buyer',
    deliveryHelpSeller: 'delivery_help_seller',
    deliveryProviderClick: 'delivery_purchase_provider_click',
    deliveryProviderSelectPoint: 'delivery_purchase_provider_select_point',
    deliveryProviderChangePoint: 'delivery_purchase_provider_change_point',
    deliveryExperienceTooltipClick: 'delivery_experience_tooltip_click',
    // service fee
    serviceFeeInvoiceLinkClick: 'service_fee_request_click',
    serviceFeeCustomerServiceCancelClick: 'service_fee_request_cs_cancel',
    serviceFeeCustomerServiceClick: 'service_fee_request_cs_click',
    serviceFeeInfoIconClick: 'service_fee_info_icon_click',
    serviceFeeInfoCloseClick: 'service_fee_info_icon_close_click',
    // seller take rate
    tooltip_take_rate: 'tooltip_take_rate',
    tooltip_take_rate_close: 'tooltip_take_rate_close',
    // safe deal returns
    safeDeal: {
      confirmDetails: 'delivery_return_confirm_details_1step',
      redoPayment: 'delivery_return_payment',
      howReturnsWork: 'delivery_return_how_it_works',
      howSafeDealWork: 'delivery_sd_how_it_works_click',
      howSafeDealWorkModalShown: 'delivery_sd_how_it_works',
      closeModalSafeDealBtn: 'delivery_sd_how_it_works_cancel',
      closeModalReturnsBtn: 'delivery_return_how_it_works_cancel',
      termsAndConditionsClick: 'sd_terms_and_conditions_click',
    },
  },
} as const;
